import services from '@/http'
import * as types from './mutation-types'

/**
 * Busca os dados do termo por token
 *
 * @param {Object} context - Contexto do Vuex
 * @param {string} token - Token de acesso ao termo
 */
export const ActionFetchByToken = async ({ commit }, token) => {
    commit(types.SET_LOADING, true)
    commit(types.SET_ERROR, null)

    try {
        const response = await services.termSignature.showByToken({ token })
        const data = response.body.data || response.body

        const signature = data.signature || data
        
        commit(types.SET_SIGNATURE, signature)
        commit(types.SET_CONTENT, data.content || signature.content)
        commit(types.SET_TERM, data.term || signature.term)
        commit(types.SET_TEACHER, data.teacher || signature.teacher)
        commit(types.SET_INSTITUTION, data.institution || signature.institution)

        return data
    } catch (error) {
        const errorData = error.body || error
        commit(types.SET_ERROR, {
            code: errorData.code || errorData.error?.code || 'UNKNOWN_ERROR',
            message: errorData.message || errorData.error?.message || 'Erro ao carregar o termo'
        })
        throw errorData
    } finally {
        commit(types.SET_LOADING, false)
    }
}

/**
 * Assina o termo usando o token
 *
 * @param {Object} context - Contexto do Vuex
 * @param {Object} payload - Dados para assinatura
 * @param {string} payload.token - Token de acesso
 * @param {boolean} payload.agree - Concordância (termos obrigatórios)
 * @param {number} payload.term_option_id - ID da opção (termos com opções)
 */
export const ActionSignByToken = async ({ commit }, { token, agree, term_option_id }) => {
    commit(types.SET_LOADING, true)
    commit(types.SET_ERROR, null)

    try {
        const response = await services.termSignature.signByToken({ token }, {
            agree,
            term_option_id
        })
        const data = response.body.data || response.body

        // Atualizar a assinatura no state após assinar
        commit(types.SET_SIGNATURE, data.signature || data)

        return data
    } catch (error) {
        const errorData = error.body || error
        commit(types.SET_ERROR, {
            code: errorData.code || 'SIGN_ERROR',
            message: errorData.message || 'Erro ao assinar o termo'
        })
        throw errorData
    } finally {
        commit(types.SET_LOADING, false)
    }
}

/**
 * Busca os dados do termo para o 2º assinante (cosigner) por access_token (RN03/RN04)
 *
 * @param {Object} context - Contexto do Vuex
 * @param {string} token - access_token do cosigner
 */
export const ActionFetchCosignerByToken = async ({ commit }, token) => {
    commit(types.SET_LOADING, true)
    commit(types.SET_ERROR, null)

    try {
        const response = await services.termSignature.showCosignerByToken({ token })
        const data = response.body.data || response.body

        const signature = data.signature || data

        commit(types.SET_SIGNATURE, signature)
        commit(types.SET_COSIGNER, data.cosigner || null)
        commit(types.SET_CONTENT, signature.content || data.content)
        commit(types.SET_TERM, signature.term || data.term)
        commit(types.SET_TEACHER, signature.teacher || data.teacher)
        commit(types.SET_INSTITUTION, signature.institution || data.institution)

        return data
    } catch (error) {
        const errorData = error.body || error
        commit(types.SET_ERROR, {
            code: errorData.code || errorData.error?.code || 'UNKNOWN_ERROR',
            message: errorData.message || errorData.error?.message || 'Erro ao carregar o termo'
        })
        throw errorData
    } finally {
        commit(types.SET_LOADING, false)
    }
}

/**
 * Assina o termo como 2º assinante (cosigner) via access_token (RN04)
 *
 * @param {Object} context - Contexto do Vuex
 * @param {Object} payload
 * @param {string} payload.token - access_token do cosigner
 * @param {boolean} payload.agree - Confirmação de assinatura
 * @param {string} [payload.justification] - Justificativa opcional
 */
export const ActionSignCosignerByToken = async ({ commit }, { token, agree, justification }) => {
    commit(types.SET_LOADING, true)
    commit(types.SET_ERROR, null)

    try {
        const response = await services.termSignature.signCosignerByToken({ token }, { agree, justification })
        const data = response.body.data || response.body

        commit(types.SET_COSIGNER, data.data || data)

        return data
    } catch (error) {
        const errorData = error.body || error
        commit(types.SET_ERROR, {
            code: errorData.code || 'SIGN_ERROR',
            message: errorData.message || 'Erro ao assinar o termo'
        })
        throw errorData
    } finally {
        commit(types.SET_LOADING, false)
    }
}

/**
 * Limpa o estado do módulo
 */
export const ActionResetState = ({ commit }) => {
    commit(types.RESET_STATE)
}
